/**
 * Created by Carsten Bühler
 * User: CBuehler on 05.01.2016
 * Copyright: xdot GmbH 2015
 */

import FluxReduceStore from 'flux/lib/FluxReduceStore';

import AsyncState from '../constants/AsyncState';
import warning from '../utils/warning';

export default class AsyncOperationStore extends FluxReduceStore {

    getOperation(key) {
        return this.getState().operationsByKey[ key ];
    }

    getOperations() {
        return this.getState().operations;
    }

    getInitialState() {
        return {
            operations: [],
            operationsByKey: {}
        };
    }

    reduce(state, action) {

        if (action.meta && action.meta.asyncState) {
            const { key, asyncState } = action.meta;
            warning(key, 'Async key expected');

            switch (asyncState) {
                case AsyncState.REQUESTED:
                    //todo use meta.className & meta.name to abort existing operations

                    return this.mutateOperation(state, key, {
                        requestPayload: {
                            ...action.payload,
                            [ 'item' ]: null
                        },
                        key,
                        asyncState
                    });

                case AsyncState.SUCCESS:
                    return this.mutateOperation(state, key, {
                        asyncState
                    });

                case AsyncState.ERROR:
                    console.warn('AsyncState.ERROR', action);
                    return this.mutateOperation(state, key, {
                        asyncState,
                        error: action.payload
                    });
                default:
                    console.warn('Unkown async state: ', action);

            }
        }


        return state;
    }


    mutateOperation(state, key, source) {
        const current = state.operationsByKey[ key ],
            newOp = {
                ...current,
                ...source
            };
        return {
            operations: current ? state.operations.map(op => op === current ? newOp : op) : state.operations.concat(newOp),
            operationsByKey: {
                ...state.operationsByKey,
                [ key ]: newOp
            }
        };
    }

}




// WEBPACK FOOTER //
// ./js/stores/AsyncOperationStore.js